import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';

import { catchError, map, mergeMap, Observable, reduce } from 'rxjs';
import { PublicLocationsRepository } from 'planning-portal-library/src/lib/core/repositories/public-location.repository';
import { PublicLocationWebRepositoryMapper } from './entities/public-Location-web-repository-mapper';
import { GLSLocation } from 'planning-portal-library/src/lib/core/domain/models/gls-location';
import { BaseResponse } from '../../shared/base.response';
import { PublicLocationWebEntity } from './entities/public-location-web-entity';
import { PublicLocationApiUrls } from './public-location-api-urls';
import { PublicLocationSequenceUpdateRequest } from 'planning-portal-library/src/lib/core/domain/models/public-location-job-sequence-update';

@Injectable({ providedIn: 'root' })
export class PublicLocationWebRepository extends PublicLocationsRepository {
  private readonly environment = injectEnvironment();
  private readonly publicLocationMapper =
    new PublicLocationWebRepositoryMapper();

  constructor(private readonly http: HttpClient) {
    super();
  }

    getPublicLocationsByJobId(request: string): Observable<GLSLocation[]> {
    return this.http
      .get<BaseResponse<PublicLocationWebEntity[]>>(
        `${this.environment.url}${PublicLocationApiUrls.GetPublicLocationsByJobId}`,
        {
          params: {
            jobId: request,
          },
        }
      )
      .pipe(
        mergeMap((response) => response.result!),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.publicLocationMapper.mapFrom))
      .pipe(
        reduce(
          (items: GLSLocation[], item: GLSLocation) => [...items, item],
          []
        )
      );
  }
  getPublicLocationsBySegmentId(request: string): Observable<GLSLocation[]> {
    return this.http
      .get<BaseResponse<PublicLocationWebEntity[]>>(
        `${this.environment.url}${PublicLocationApiUrls.GetPublicLocationsBySegmentId}`,
        {
          params: {
            segmentId: request,
          },
        }
      )
      .pipe(
        mergeMap((response) => response.result!),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.publicLocationMapper.mapFrom))
      .pipe(
        reduce(
          (items: GLSLocation[], item: GLSLocation) => [...items, item],
          []
        )
      );
  }

  getUnAssignedPublicLocationsByPlanId(
    request: string
  ): Observable<GLSLocation[]> {
    return this.http
      .get<BaseResponse<PublicLocationWebEntity[]>>(
        `${this.environment.url}${PublicLocationApiUrls.GetUnAssignedPublicLocationsByPlanId}`,
        {
          params: {
            planId: request,
          },
        }
      )
      .pipe(
        mergeMap((response) => response.result!),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.publicLocationMapper.mapFrom))
      .pipe(
        reduce(
          (items: GLSLocation[], item: GLSLocation) => [...items, item],
          []
        )
      );
  }

  override updatePublicLocationSequence(
    locations: PublicLocationSequenceUpdateRequest[]
  ) {
    return this.http
      .post<BaseResponse<boolean>>(
        `${this.environment.url}${PublicLocationApiUrls.UpdatePublicLocationJobAndSequence}`,
        locations
      )
      .pipe(
        map((response: BaseResponse<boolean>) => response.successful),
        catchError((err) => {
          throw err;
        })
      );
  }
}
